/**
 * RENDER module — named constants for camera, post pipeline, and grade.
 * Owned by RENDER; see CONTRACTS.md.
 */

// --- Camera -----------------------------------------------------------------
export const FIELD_OF_VIEW_DEG = 70
export const NEAR_PLANE = 0.1
export const FAR_PLANE = 200

// --- Composer ---------------------------------------------------------------
/** MSAA samples on the composer's HDR target (WebGL2). */
export const MSAA_SAMPLES = 4

// --- Selective bloom (luminance-thresholded, pre-tonemap) -------------------
/**
 * Threshold sits above any lit-but-non-emissive surface in the noir grade;
 * only emissive/neon materials (HDR luminance > 1) cross it and bloom.
 */
export const DEFAULT_BLOOM_THRESHOLD = 0.85
export const DEFAULT_BLOOM_STRENGTH = 0.7
export const DEFAULT_BLOOM_RADIUS = 0.25

// --- Noir grade -------------------------------------------------------------
/**
 * 0..1 — how fully color collapses to luminance B&W (1 = pure mono).
 * Held slightly below 1 so saturated emissives (the blue neon) keep a trace
 * of hue inside the silver-print grade.
 */
export const DEFAULT_BW_MIX = 0.9
/** 0..1 — strength of the warm sepia lift over the mono grade. */
export const DEFAULT_SEPIA_AMOUNT = 0.16
/** Warm silver-print tint applied by the sepia lift. */
export const SEPIA_TINT_R = 1.12
export const SEPIA_TINT_G = 1.0
export const SEPIA_TINT_B = 0.82
/** Levels remap: crush everything below this to black. */
export const DEFAULT_BLACK_POINT = 0.045
/** Levels remap: push everything above this to white. */
export const DEFAULT_WHITE_POINT = 0.92

// --- Film grain -------------------------------------------------------------
/** Approximate grain cell size in physical pixels (bigger = chunkier grain). */
export const DEFAULT_GRAIN_SIZE_PX = 2.2
/** How much grain recedes in bright areas (filmic response). */
export const GRAIN_HIGHLIGHT_SUPPRESSION = 0.6
/** Irrational drift rate keeps the per-frame noise seed from cycling. */
export const GRAIN_TIME_DRIFT = 0.731
/** Spatial offset multiplier applied to the time seed. */
export const GRAIN_SEED_SPREAD = 97.0

// --- Vignette ---------------------------------------------------------------
/** Normalized radial distance where vignette starts (0 = center). */
export const VIGNETTE_INNER_RADIUS = 0.35
/** Normalized radial distance where vignette reaches full strength. */
export const VIGNETTE_OUTER_RADIUS = 1.12

// --- Time -------------------------------------------------------------------
export const MS_PER_SECOND = 1000
